import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, setToken } from "@/lib/site";
import logo from "@/assets/logo.png";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Enter your email and password.");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setToken(r.data.token);
      toast.success("Welcome back!");
      onSuccess();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#06040A] flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md bg-[#130A1F]/70 border border-[#D4AF37]/25 p-8 sm:p-10">
        <div className="flex flex-col items-center mb-8">
          <img src={logo} alt="The Change Center Church" className="h-16 w-16 object-cover rounded-lg border border-[#D4AF37]/40 mb-4" />
          <h1 className="font-display text-3xl gold-text font-bold">Ministry Dashboard</h1>
          <p className="text-[#A19CA8] text-sm mt-1 flex items-center gap-1.5">
            <Lock className="h-3.5 w-3.5" /> Authorized access only
          </p>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="block text-sm uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="ccc-input"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="block text-sm uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="ccc-input"
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#D4AF37] to-[#B5952F] text-[#06040A] font-semibold uppercase tracking-wider text-sm px-8 py-4 hover:from-[#F3D56D] hover:to-[#D4AF37] transition-all duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
          </button>
        </form>

        <a href="/" className="block text-center text-[#A19CA8] hover:text-[#D4AF37] text-sm mt-6 transition-colors">
          ← Back to website
        </a>
      </div>
    </div>
  );
};
